var _defs, _g, _path, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204,
    zoomAndPan: "magnify",
    viewBox: "0 0 153 153.000002",
    height: 204,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "2684eead95"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.699219 7.878906 L 69 7.878906 L 69 99 L 15.699219 99 Z M 15.699219 7.878906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "78502cef78"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19 72 L 124 72 L 124 133.058594 L 19 133.058594 Z M 19 72 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "767a31e5e0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 75 7.878906 L 127.46875 7.878906 L 127.46875 99 L 75 99 Z M 75 7.878906 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2684eead95)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#009cdf",
    d: "M 15.777344 38.054688 L 68.09375 7.878906 L 68.101562 30.859375 L 58.089844 36.597656 L 58.089844 25.210938 L 25.8125 43.835938 L 25.8125 81.117188 L 58.089844 62.472656 L 58.089844 51.238281 L 68.109375 45.5 L 68.117188 68.246094 L 15.804688 98.441406 Z M 15.777344 38.054688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004a89",
    d: "M 48.28125 56.800781 L 35.65625 64.089844 L 35.613281 49.492188 L 48.28125 42.226562 Z M 48.28125 56.800781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#78502cef78)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004a89",
    d: "M 40.789062 90.445312 L 83.058594 114.851562 L 71.554688 121.488281 L 39.273438 102.867188 L 44.542969 99.824219 L 34.53125 94.050781 L 19.253906 102.871094 L 71.570312 133.058594 L 103.0625 114.855469 L 60.800781 90.441406 L 71.566406 84.226562 L 103.839844 102.855469 L 97.917969 106.304688 L 107.894531 112.097656 L 123.867188 102.851562 L 71.566406 72.652344 Z M 40.789062 90.445312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#767a31e5e0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#004a89",
    d: "M 127.34375 62.878906 L 85.054688 38.5 L 85.054688 25.207031 L 117.332031 43.84375 L 117.332031 49.929688 L 127.347656 55.710938 L 127.359375 38.070312 L 75.050781 7.878906 L 75.042969 44.285156 L 117.363281 68.683594 L 117.332031 81.105469 L 85.054688 62.484375 L 85.054688 55.734375 L 75.035156 49.992188 L 75.023438 68.269531 L 127.335938 98.445312 Z M 127.34375 62.878906 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/CSS.0870a040c88e0f816b9e6baee4449c20.svg";
export { ForwardRef as ReactComponent };